import { BILLING_CYCLES, type BillingCycle } from './const';

const BILLING_CYCLE_LABEL: Record<BillingCycle, string> = {
  [BILLING_CYCLES.monthly]: 'Monthly',
  [BILLING_CYCLES.annually]: 'Yearly',
};

export const getBillingCycleLabel = (cycle: BillingCycle): string =>
  BILLING_CYCLE_LABEL[cycle] || cycle;
